import React from 'react';

const TransactionTable = ({ transactions }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return '#28a745';
      case 'pending':
        return '#ffc107';
      case 'failed':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ 
        width: '100%', 
        borderCollapse: 'collapse',
        fontSize: '14px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa' }}>
            <th style={{ 
              padding: '12px', 
              textAlign: 'left', 
              borderBottom: '2px solid #dee2e6',
              fontWeight: 'bold'
            }}>
              ID
            </th>
            <th style={{ 
              padding: '12px', 
              textAlign: 'left', 
              borderBottom: '2px solid #dee2e6',
              fontWeight: 'bold'
            }}>
              Date
            </th>
            <th style={{ 
              padding: '12px', 
              textAlign: 'left', 
              borderBottom: '2px solid #dee2e6',
              fontWeight: 'bold'
            }}>
              Description
            </th>
            <th style={{ 
              padding: '12px', 
              textAlign: 'right', 
              borderBottom: '2px solid #dee2e6',
              fontWeight: 'bold'
            }}>
              Amount
            </th>
            <th style={{ 
              padding: '12px', 
              textAlign: 'center', 
              borderBottom: '2px solid #dee2e6',
              fontWeight: 'bold'
            }}>
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index) => (
            <tr key={transaction.id || index} style={{ 
              borderBottom: '1px solid #dee2e6',
              backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
            }}>
              <td style={{ padding: '12px' }}>
                {transaction.id || 'N/A'}
              </td>
              <td style={{ padding: '12px' }}>
                {transaction.date ? formatDate(transaction.date) : 'N/A'}
              </td>
              <td style={{ padding: '12px' }}>
                {transaction.description || transaction.type || 'N/A'}
              </td>
              <td style={{ 
                padding: '12px', 
                textAlign: 'right',
                fontWeight: 'bold',
                color: transaction.amount >= 0 ? '#28a745' : '#dc3545'
              }}>
                {transaction.amount !== undefined ? formatCurrency(transaction.amount) : 'N/A'}
              </td>
              <td style={{ padding: '12px', textAlign: 'center' }}>
                <span style={{
                  padding: '4px 8px',
                  borderRadius: '4px',
                  backgroundColor: getStatusColor(transaction.status),
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {transaction.status || 'Unknown'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {transactions.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px',
          color: '#6c757d'
        }}>
          No transactions to display
        </div>
      )}
    </div>
  );
};

export default TransactionTable;
